import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Shell from "../Shell";
import api, { authHeaders } from "../api";

function fmt(d) {
  if (!d) return "—";
  const dt = new Date(d);
  if (String(dt) === "Invalid Date") return d;
  const dd = String(dt.getDate()).padStart(2, "0");
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const yyyy = dt.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

export default function GroupAttendance() {
  const [rows, setRows] = useState([]);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const canHouseMark = role === "admin" || role === "staff";

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      try {
        const [groupsRes, roleRes] = await Promise.all([
          api.get("/api/attendance/groups/", { headers: authHeaders() }),
          api.get("/api/user/role/", { headers: authHeaders() }),
        ]);

        const list = Array.isArray(groupsRes.data) ? groupsRes.data : [];
        const r = roleRes?.data?.role || "staff";
 

        if (alive) {
          setRole(r);
          setRows(list);
        }
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <Shell title="Hugarafl starfsfólk" rightMenu>
      <h2 style={{ textAlign: "center", margin: "8px 0 18px" }}>Skrá mætingu</h2>

      {/* Top action bar */}
      {canHouseMark && (
        <div className="members-toolbar" style={{ justifyContent: "flex-end", marginBottom: 8 }}>
          <Link to="/attendance/house" className="btn sm">
            Skrá mætingu í hús
          </Link>
        </div>
      )}

      {loading ? (
        <div className="loading">Hleð…</div>
      ) : (
        <div className="table-wrap">
          <table className="table zebra" style={{ minWidth: 520 }}>
            <thead>
              <tr>
                <th>Hópanafn</th>
                <th>Síðast skráð</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={3} style={{ textAlign: "center", padding: 16 }}>
                    Engir hópar fundust.
                  </td>
                </tr>
              ) : (
                rows.map((g) => {
                  const to = g.__house ? "/attendance/house" : `/attendance/group/${g.id}`;
                  return (
                    <tr key={`${g.__house ? "house" : g.id}`}>
                      <td>{g.name}</td>
                      <td>{fmt(g.last_marked)}</td>
                      <td style={{ textAlign: "right" }}>
                        <Link to={to} className="btn sm">
                          Skrá mætingu
                        </Link>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      )}
    </Shell>
  );
}